export const UserModel = {
  username: "",
  email: "",
  password: ""
}

export const UserValidator = {
  username: [
    {
      required: true,
      trigger: "blur",
      transform: (value: string) => value.trim()
    },
    {
      min: 2,
      max: 32,
      trigger: "blur"
    }
  ],
  email: [
    {
      required: true,
      trigger: "blur"
    },
    {
      type: "email",
      trigger: "blur"
    }
  ],
  password: [
    {
      required: true,
      trigger: "blur"
    },
    {
      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{8,}$/,
      message: "password must be at least 8 character and have at least: one lowercase, one uppercase and one digit",
      trigger: "blur"
    }
  ]
}
